import { Routes } from '@angular/router';

export const QUALIFICATIONS_ROUTES: Routes = [
  { path: 'admin-components', loadComponent: () => import('./components/qualification-admin-component-list/qualification-admin-component-list.component').then(m => m.QualificationAdminComponentListComponent) },
  { path: ':id', loadComponent: () => import('./components/qualification-view/qualification-view.component').then(m => m.QualificationViewComponent) },
  { path: '', loadComponent: () => import('./components/qualification-list/qualification-list.component').then(m => m.QualificationListComponent) }
];
